import NodeEvents from 'events';
import * as Inovx from '@shared';
import FacilityConstants from './../constants/FacilityConstants';
import assign from 'object-assign';
import ConfigurationConstants from '../constants/ConfigurationConstants';
import TaxonomyConstants from '../constants/TaxonomyConstants';
import ViewerConstants from '../constants/ViewerConstants';
import OntologyConstants from '../constants/OntologyConstants';
import GraphicSourceConstants from '../constants/GraphicSourceConstants';
import { FACILITY_SLIDEOUT_PANEL_IDS, isFacilitySlideoutPanelFloating } from '../helpers/facilitySlideoutPanelSession';
var EventEmitter = NodeEvents.EventEmitter;
var CommonMessages = Inovx.Shared.Common.CommonMessages;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var CHANGE_EVENT = 'Facility.change'
var FORM_ADD_FACILITY_NAME = FacilityConstants.FACILITY_ADD_FORM;

const blankAssetClassUpdateDetail: IAssetClassUpdateDetail = {
    ID: "",
    Name: "",
    SchemaID: "",
    PrimaryAssetClassID: null,
    TagDisplayData: {
        FontColor: "#000000",
        FontSize: 14,
        FontStyle: "Regular",
        LineColor: "#000000",
        LineThickness: 1,
        TagColor: "#FFFFFF",
        TagShape: "Rectangle",
        TagTransparency: 0.7
    },
    AttributeDefinitions: [],
    FriendClasses: [],
    AutoPopulateAssetSets: false,
    AutoPopulateAssetSetClassificationTags: [],
    ExternalDataSourceLinks: [],
    ExternalAttributeDefinitions: [],
};

const defaultTabsError = { Details: false, Integrations: false };
var _facilities: IFacility[] = [],
    _facilityDetails: IFacilityDetail = null,
    _facility: IFacilityDetail | any = getBlankFacility(),
    _searchResults: IFacility[] = null,
    _modalVisible = false,
    _sidebarOpen = false,
    _searchbarOpen = false,
    _assetSearchbarOpen = false,
    _beginAdd = false,
    _beginEdit = false,
    _hasChanges = false,
    _selectedTab = '',
    _validation: IValidationStoreObject = {},
    _schemas: ISchema[],
    _assetUpdateClasses: IAssetClassUpdateDetail[],
    _configurationModalVisible = false,
    _taxonomyModalVisible = false,
    _ontologyModalVisible = false,
    _dataSourcesVisible = false,
    _cad3dModalVisible = false,
    _selectedGraphicSource: IGraphicSource = null,
    _hasGraphicSourceChange: boolean = false,
    _graphicSources: IGraphicSource[] = [],
    _configuration: IAssetClassUpdateDetail = { ...blankAssetClassUpdateDetail },
    _hasSchemaChanges = false,
    _knowledgeBookOpen = false,
    _knowledgeViewEditBarOpen = false,
    _facilityAssetSetsBarOpen = false,
    _assetSetVisualizationBarOpen = false,
    _knowledgeLibraryOpen = false,
    _mediaGalleryOpen = false,
    _mediaGalleryViewMode: MediaGalleryViewMode = 'thumbnail',
    _adapters: any = [],
    _xmlEditorOpen: boolean = false,
    _xmlEditorData: IFacilityAdapterConfiguration = null,
    _isFormSubmitted: boolean = false,
    _tabError: IFacilityTabsError = Object.assign({}, defaultTabsError),
    _measurementBarOpen: boolean = false,
    _assemblyLibraryBarOpen: boolean = false,
    _assetTagBarOpen: boolean = false,
    _knowledgeLibraryCardUrlState: KnowledgeLibraryCardUrlState = { isCardView: true },
    _selectedOntology: IOntologyPart = null,
    _camPosition: any = null,
    _camRotation: any = null,
    _ontologyFormDirty: boolean = false,
    _rootOntologyContentTypes: string[] = [],
    _selectedOntologyContentTypes: string[] = null,
    _hasTaxonomyChanges = false,
    _libraryTaxonomy: ILibraryTaxonomyDetail[] = [],
    _taxonomyClassificationDetail: ILibraryTaxonomyDetail = null,
    _visibleTaxonomyClassificationDetail: ILibraryTaxonomyDetail = null,
    _taxonomyAssetSetClassificationDetail: ILibraryTaxonomyDetail = null,
    _visibleTaxonomyAssetSetClassificationDetail: ILibraryTaxonomyDetail = null,
    _schemaAssetSetTaxonomyDetail: ILibraryTaxonomyDetail = null;

// Cached projection returned by getFacilityAssetsData(). The getter is called
// during render by several panels, so a fresh object literal per call breaks
// every downstream useMemo/React.memo that depends on it. The cache is keyed on
// the identities the projection is built from; the store deliberately re-creates
// those arrays whenever their content changes.
let _facilityAssetsData: IFacilityAssetsData = null;

function getCachedFacilityAssetsData(): IFacilityAssetsData {
    if (!_facilityDetails) {
        _facilityAssetsData = null;
        return null;
    }

    if (_facilityAssetsData
        && _facilityAssetsData.Facility === _facilityDetails
        && _facilityAssetsData.Assets === _facilityDetails.Assets
        && _facilityAssetsData.NativeAssets === _facilityDetails.NativeAssets
        && _facilityAssetsData.AssetTags === _facilityDetails.AssetTags) {
        return _facilityAssetsData;
    }

    _facilityAssetsData = {
        Facility: _facilityDetails,
        Assets: _facilityDetails.Assets,
        NativeAssets: _facilityDetails.NativeAssets,
        AssetTags: _facilityDetails.AssetTags
    };

    return _facilityAssetsData;
}
    
function setAddingFacility() {
    _beginAdd = _modalVisible = true;
    _dataSourcesVisible = false;
    _beginEdit = false;
    _hasChanges = false;
    _isFormSubmitted = false;
    _tabError = Object.assign({}, defaultTabsError);
    _facility = getBlankFacility();
    _initalizeValidation(FORM_ADD_FACILITY_NAME);
}

function setEditingFacility(facility: IFacilityDetail) {
    _modalVisible = _beginEdit = true;
    _dataSourcesVisible = false;
    _beginAdd = false;
    _hasChanges = false;
    _isFormSubmitted = false;
    _tabError = Object.assign({}, defaultTabsError);
    //_facility = JSON.parse(JSON.stringify(facility));
    _facility = { ...facility };
    _initalizeValidation(FORM_ADD_FACILITY_NAME);
}
function finishedEditingFacility(close: boolean) {
    _modalVisible = close ? false : true;
    _hasChanges = false;
    _isFormSubmitted = false;
    _tabError = Object.assign({}, defaultTabsError);
}

function setFacilityDetails(facility: IFacilityDetail) {
    resetFacilityDetails();

    _facilityDetails = { ...facility };
    fixFacilityDetailData(_facilityDetails);

    _rootOntologyContentTypes = buildOntologyContentTypes(getRootOntology());
}

function setCameraProperties (camPosition: IVector3D, camRotation: IQuaternion) {
    _camPosition = camPosition;
    _camRotation = camRotation;
}

function updateFacilityDetails(facility: IFacilityDetail) {
    _facilityDetails = { ...facility };
}
function resetFacilityDetails() {
    _facilityDetails = null;
    _dataSourcesVisible = false;
    _rootOntologyContentTypes = [];
    _selectedOntology = null;
    _selectedOntologyContentTypes = null;
}
function _initalizeValidation(comp: string) {
    switch (comp) {
        case FORM_ADD_FACILITY_NAME:
            _validation[FORM_ADD_FACILITY_NAME] = {};
            for (var k in _facility) {
                _setValidValidation(FORM_ADD_FACILITY_NAME, k);
            }
            break;
    }
}

function _setValidValidation(comp: string, name: string) {
    if (_validation[comp][name]) {
        _validation[comp][name].invalidInput = false;
        _validation[comp][name].invalidValue = false;
    } else {
        _validation[comp][name] = _getNewValidationObject();
    }
}

function _getNewValidationObject() {
    return {
        invalidInput: false,
        invalidValue: false
    } as IValidationObject;
}

function _validate(comp: string) {
    let flag = false;
    switch (comp) {
        case FORM_ADD_FACILITY_NAME:
            flag = _validateObject(comp, _facility);
    }
    if (!flag) {
        _tabError.Details = true;
    } else {
        _tabError.Details = false;
    }
    return flag;
}
function _validateIntegration() {
    _isFormSubmitted = true;
    let flag: boolean = true;
    if (_adapters && _adapters.length > 0) {
        _adapters.filter((item: any) => item.FacilityID != null).map((item: any) => {
            item.AdapterConfigurationItemModels.map((input: IFacilityAdapterConfiguration, key: number) => {
                if (input.IsRequired && !input.Value) {
                    flag = false;
                };
            })
        })
    }
    if (!flag) {
        _tabError.Integrations = true;
    } else {
        _tabError.Integrations = false;
    }
    return flag;
}


function _ensureValidObject(comp: string, obj: any) {
    for (var k in obj) {
        switch (comp) {
            case FORM_ADD_FACILITY_NAME:
                var objType = typeof (obj[k]);
                if (objType !== 'function') {
                    if (obj[k] === null || objType !== 'object') {
                        _updateChanges(k, obj[k]);
                    } else {
                        _ensureValidObject(comp, obj[k]);
                    }
                }
        }
    }
}

function _validateObject(comp: string, obj: any) {
    //let newObj = JSON.parse(JSON.stringify(obj))
    let newObj = { ...obj };
    _ensureValidObject(comp, newObj);

    var ret = true;

    for (var k in _validation[FORM_ADD_FACILITY_NAME]) {
        if (_validation[FORM_ADD_FACILITY_NAME][k].invalidValue) {
            return false;
        }
    }

    return ret;
}

function _isNumeric(str: string) {
    return /^-?\d+(\.\d+)?$/.test(str);
}

function _updateChanges(name: string, value: any) {
    switch (name) {
        case "Name":
            _facility[name] = value;
            if (value) {
                var dupName = false;
                for (var i = 0; i < _facilities.length; i++) {
                    if (_facility.Name.toUpperCase() === _facilities[i].Name.toUpperCase()
                        && _facility.ID.toUpperCase() !== _facilities[i].ID.toUpperCase()) {
                        dupName = true;
                        break;
                    }
                }

                if (dupName) {
                    _validation[FORM_ADD_FACILITY_NAME][name].invalidValue = true;
                    _validation[FORM_ADD_FACILITY_NAME][name].invalidValueMessage = InovxLoader.t("facility:message.invalidFacility");
                } else {
                    _setValidValidation(FORM_ADD_FACILITY_NAME, name);
                }
            } else {
                _validation[FORM_ADD_FACILITY_NAME][name].invalidValue = true;
                _validation[FORM_ADD_FACILITY_NAME][name].invalidValueMessage = CommonMessages.Validation.Required;
            }
            break;
        case "SchemaID":
            _facility[name] = value;
            if (value) {
                _setValidValidation(FORM_ADD_FACILITY_NAME, name);
            } else {
                _validation[FORM_ADD_FACILITY_NAME][name].invalidValue = true;
                _validation[FORM_ADD_FACILITY_NAME][name].invalidValueMessage = CommonMessages.Validation.Required;
            }
            break;
        default:
           if (name != 'ID' && name != 'VersionToken') {
                _facility[name] = value;
            }

            _setValidValidation(FORM_ADD_FACILITY_NAME, name);
            break;
    } 
}

function updateCurrentProperty(comp: string, key: string, value: any) {
    switch (comp) {
        case FORM_ADD_FACILITY_NAME:
            _updateChanges(key, value);
            _hasChanges = true;
            break;
    }
}

function loadAllFacilities(data: IFacility[]) {
    fixFacilitiesData(data);
    _facilities = data;
}

function loadAllSchemas(data: ISchema[]) {
    _schemas = data;
}

function setAssetUpdateClasses(data: IAssetClassUpdateDetail[]) {
    _assetUpdateClasses = data;
}

function updateAssetUpdateClass(data: IAssetClassUpdateDetail) {
    if (_assetUpdateClasses) {
        _assetUpdateClasses = _assetUpdateClasses.filter(o => o.ID !== data.ID); // remove old version of asset class; need to re-create the array to trigger change
    }
    else {
        _assetUpdateClasses = [];
    }

    _assetUpdateClasses.push(data);
    _configuration = data;
    _hasSchemaChanges = true;
}

function loadSearchResults(data: IFacility[]) {
    fixFacilitiesData(data);
    _searchResults = data;
}

function getBlankFacility(): IFacilityDetail {
    return {
        ID: "",
        VersionToken: "",
        Name: "",
        Location: "",
        Synopsis: "",
        ThumbnailImageUrl: null,
        ThumbnailData: null,
        Views: [],
        SchemaID: "",
        Schemas: [],
        AssetClasses: [],
        AnnotationClasses: [],
        Assets: [],
        AssetTags: [],
        KBTaxonomyID: "",
        AssetSetTaxonomyID: ""
    }
}

export function getBlankSiteMap(): ISiteMap {
    return {
        Scale: 0,
        Rotation: 0,
        MapFileImageUrl: "",
        MapPreview: "",
        ImageTranslation: { X: 0, Y: 0 },
        ImageScale: { X: 0, Y: 0 },
        WorldTranslation: { X: 0, Y: 0 },
        WorldScale: { X: 0, Y: 0 },
        Origin: { X: 0, Y: 0 },
        ImageSize: { X: 0, Y: 0 },
        RealWorldMin: { X: 0, Y: 0 },
        RealWorldMax: { X: 0, Y: 0 },
        ImageMarkers: [],
        RealWorldMarkers: []
    }
}


function fixFacilitiesData(data: IFacility[]) {
    if (data) {
        data.forEach((facility) => {
            fixFacilityData(facility);
        });
    }
}

function fixFacilityData(facility: IFacility) {
    if (facility) {
        facility.ThumbnailImageUrl = (facility.ThumbnailImageUrl) ? UrlUtilities.getImageBaseUrl() + facility.ThumbnailImageUrl : null;
        facility.Schemas = facility.Schemas || [];
    }
}

function fixFacilityDetailData(facility: IFacilityDetail) {
    if (facility) {
        fixFacilityData(facility);
        facility.Views?.forEach((view) => {
            view.DepthMapUrl = (view.DepthMapUrl) ? (UrlUtilities.getImageBaseUrl() + view.DepthMapUrl) : null;
            view.ImageUrl = (view.ImageUrl) ? (UrlUtilities.getImageBaseUrl() + view.ImageUrl) : null;
            view.ThumbnailImageUrl = (view.ThumbnailImageUrl) ? (UrlUtilities.getImageBaseUrl() + view.ThumbnailImageUrl) : null;
            if (view.ScanFileData) {

                view.ScanFileData = JSON.parse(view.ScanFileData as any);
                view.ScanFileData.ScanDatas.forEach((data) => {
                    data.ScanFileUrl = (data.ScanFileUrl) ? (UrlUtilities.getImageBaseUrl() + data.ScanFileUrl) : null;
                });
            }
        });
        facility.Assets?.forEach((a) => {
            fixAssetData(a, facility);
        }); 
        facility.NativeAssets?.forEach((nativeAsset) => {
            fixNativeAssetData(nativeAsset, facility);
        });
        facility.AssetTags?.forEach((tag) => {
            fixAssetTagData(tag, facility);
        });
        facility.OntologyParts?.forEach((part) => {
            part.IsRoot = part.OntologyParentID === null;
            if (part.MapType === "inherit") {
                let parentCheckPart = part;
                while (parentCheckPart.OntologyParentID) {
                    parentCheckPart = facility.OntologyParts.find(o => o.ID === parentCheckPart.OntologyParentID);
                    if (parentCheckPart.MapType !== "inherit") {
                        part.Map = parentCheckPart.Map;
                        break;
                    }
                }
            }
            else {
                if (part.Map) {
                    fixSiteMapData(part.Map);
                }
            }
        });
    }
}

function fixSiteMapData(map: ISiteMap) {
    map.MapPreview = map.MapFileImageUrl ? `${UrlUtilities.getImageBaseUrl()}${map.MapFileImageUrl}` : "";
    map.ImageTranslation = { X: 0, Y: 0 };
    map.ImageScale = { X: 0, Y: 0 };
    map.WorldTranslation = { X: 0, Y: 0 };
    map.WorldScale = { X: 0, Y: 0 };
    if (map.ImageMarkers) {
        if (map.ImageMarkers.length > 0) {
            map.ImageTranslation = map.ImageMarkers[0];
            if (map.ImageMarkers.length > 1) {
                map.ImageScale = map.ImageMarkers[1];
            }
        }
    }
    if (map.RealWorldMarkers) {
        if (map.RealWorldMarkers.length > 0) {
            map.WorldTranslation = map.RealWorldMarkers[0];
            if (map.RealWorldMarkers.length > 1) {
                map.WorldScale = map.RealWorldMarkers[1];
            }
        }
    }
}

function fixAssetData(a: IAssetIdentity, facility: IFacilityDetail) {
    a.AssetClass = facility.AssetClasses.find(o => o.ID === a.AssetClassID);
}

function fixNativeAssetData(nativeAsset: INativeAsset, facility: IFacilityDetail) {
    nativeAsset.ApplicableOntologyIDs = nativeAsset.ApplicableOntologyIDs || [];
}

function fixAssetTagData(tag: IAssetTag, facility: IFacilityDetail) {
    const asset = facility.Assets.find(o => o.ID === tag.AssetID);
    tag.ApplicableOntologyIDs = tag.ApplicableOntologyIDs || [];
    tag.AssetClass = asset.AssetClass;
    tag.Text = asset.Identity;
    tag.AnnotationType = tag.TargetBoxMin ? AnnotationType.AssetTagWithBox : AnnotationType.AssetTag;
    tag.View = facility.Views.find(v => v.ID === tag.View360ID);
}

function refreshAssetTagData(newTagData: { tag: IAssetTag, asset: IAssetIdentity, nativeAsset: INativeAsset, deletedAssetID?: string }) {
    const facility: IFacilityDetail = _facilityDetails;
    const tag = newTagData.tag;

    facility.AssetTags = facility.AssetTags.filter(o => o.ID !== tag.ID); // remove old version of tag; need to re-create the array to trigger change

    if (newTagData.deletedAssetID) {
        facility.Assets = facility.Assets.filter(o => o.ID !== newTagData.deletedAssetID); // remove old asset (if it was deleted))
    }

    if (newTagData.nativeAsset) {
        const nativeAsset = newTagData.nativeAsset;
        fixNativeAssetData(nativeAsset, facility);
        facility.NativeAssets = facility.NativeAssets.filter(o => o.ID !== nativeAsset.ID); // remove old version of native asset; need to re-create the array to trigger change
        facility.NativeAssets.push(nativeAsset); // add new native asset
    }
    
    if (newTagData.asset) {
        const asset = newTagData.asset;
        fixAssetData(asset, facility);
        facility.Assets = facility.Assets.filter(o => o.ID !== asset.ID); // remove old version of asset; need to re-create the array to trigger change
        facility.Assets.push(asset); // add new asset version

        // update all tags that reference this asset
        facility.AssetTags?.filter(o => o.AssetID === asset.ID).forEach((tag) => {
            fixAssetTagData(tag, facility);
        });
    }

    fixAssetTagData(tag, facility);
    facility.AssetTags.push(tag); // add new tag version
}

function deleteAssetTag(deletedTagData: { deletedTagID: string, deletedAssetID: string }) {
    const facility: IFacilityDetail = _facilityDetails;

    if (deletedTagData.deletedAssetID) {
        facility.Assets = facility.Assets.filter(o => o.ID !== deletedTagData.deletedAssetID); // need to re-create the array to trigger change
    }

    facility.AssetTags = facility.AssetTags.filter(o => o.ID !== deletedTagData.deletedTagID); // need to re-create the array to trigger change
}

function createFacilityHierarchy() {
    const hierarchyParts: IFacilityHierarchyPart[] = _facilityDetails.OntologyParts.map((part) => {
        return {
            ...part,
            Children: [] as IFacilityHierarchyPart[],
            InheritedContentTypes: new Set(part.ContentTypes ?? [])
        };
    });
    
    let hierarchyRoot: IFacilityHierarchyPart;

    // Index parts for easy lookup
    const partMap = new Map<string, IFacilityHierarchyPart>();
    hierarchyParts.forEach(part => partMap.set(part.ID, part));

    hierarchyParts.forEach((part) => {
        if (part.IsRoot) {
            hierarchyRoot = part;
        }
        part.Children = hierarchyParts.filter(o => o.OntologyParentID === part.ID).sort((a, b) => {
            return a.Name.localeCompare(b.Name);
        });
    });

    function propagateDown(node: IFacilityHierarchyPart, inherited: Set<string>) {
        inherited.forEach(ct => {
            node.InheritedContentTypes.add(ct);
        });
        for (const child of node.Children) {
            propagateDown(child, node.InheritedContentTypes);
        }
    }
    propagateDown(hierarchyRoot, new Set());

    function propagateUp(node: IFacilityHierarchyPart): Set<string> {
        const allTypes = new Set(node.InheritedContentTypes);
        for (const child of node.Children) {
            const childTypes = propagateUp(child);
            childTypes.forEach(ct => {
                allTypes.add(ct);
                node.InheritedContentTypes.add(ct);
            });
        }
        return allTypes;
    }
    propagateUp(hierarchyRoot);

    hierarchyParts.forEach(part => {
        const arr: string[] = [];
        part.InheritedContentTypes.forEach(ct => arr.push(ct));
        part.InheritedContentTypes = arr as any; 
    });

    return hierarchyRoot!;
}

function openSidebar() {
    _sidebarOpen= true;
}
function closeSidebar() {
    _sidebarOpen = false;
}

function openSearchbar() {
    _searchbarOpen = true;
}
function closeSearchbar() {
    _searchbarOpen = false;
}

type FacilitySlideoutPanelKey = 'asset-tags' | 'knowledge-book' | 'knowledge-view-edit' | 'facility-asset-sets' | 'asset-set-visualization' | 'measurements' | 'assembly-library';

function closeSlideoutPanelsExcept(activePanel: FacilitySlideoutPanelKey) {
    if (isFacilitySlideoutPanelFloating(activePanel)) {
        return;
    }

    if (activePanel !== 'asset-tags' && !isFacilitySlideoutPanelFloating(FACILITY_SLIDEOUT_PANEL_IDS.assetTags)) {
        _assetSearchbarOpen = false;
        _assetTagBarOpen = false;
    }
    if (activePanel !== 'knowledge-book' && !isFacilitySlideoutPanelFloating(FACILITY_SLIDEOUT_PANEL_IDS.knowledgeBook)) {
        _knowledgeBookOpen = false;
    }
    if (activePanel !== 'knowledge-view-edit' && !isFacilitySlideoutPanelFloating(FACILITY_SLIDEOUT_PANEL_IDS.knowledgeViewEdit)) {
        _knowledgeViewEditBarOpen = false;
    }
    if (activePanel !== 'facility-asset-sets' && !isFacilitySlideoutPanelFloating(FACILITY_SLIDEOUT_PANEL_IDS.facilityAssetSets)) {
        _facilityAssetSetsBarOpen = false;
    }
    if (activePanel !== 'asset-set-visualization' && !isFacilitySlideoutPanelFloating(FACILITY_SLIDEOUT_PANEL_IDS.assetSetVisualization)) {
        _assetSetVisualizationBarOpen = false;
    }
    if (activePanel !== 'measurements' && !isFacilitySlideoutPanelFloating(FACILITY_SLIDEOUT_PANEL_IDS.measurements)) {
        _measurementBarOpen = false;
    }
    if (activePanel !== 'assembly-library' && !isFacilitySlideoutPanelFloating(FACILITY_SLIDEOUT_PANEL_IDS.assemblyLibrary)) {
        _assemblyLibraryBarOpen = false;
    }
}

function openAssetSearchbar() {
    closeSlideoutPanelsExcept('asset-tags');
    _assetSearchbarOpen = true;
    _assetTagBarOpen = true; // Keep in sync for viewer switching
}
function closeAssetSearchbar() {
    _assetSearchbarOpen = false;
    _assetTagBarOpen = false; // Keep in sync for viewer switching
}

function updateSelectedTab(tab='') {
    _selectedTab = tab;
}

function openDataSources() {
    _modalVisible = false;
    _configurationModalVisible = false;
    _taxonomyModalVisible = false;
    _ontologyModalVisible = false;
    _dataSourcesVisible = true;
}

function closeDataSources() {
    _dataSourcesVisible = false;
}

function toggleKnowledgeBookbar(flag:boolean) {
    if (flag) {
        closeSlideoutPanelsExcept('knowledge-book');
    }
    _knowledgeBookOpen = flag;
}

function toggleKnowledgeViewEditBar(flag: boolean) {
    if (flag) {
        closeSlideoutPanelsExcept('knowledge-view-edit');
    }
    _knowledgeViewEditBarOpen = flag;
}

function toggleFacilityAssetSetsbar(flag:boolean) {
    if (flag) {
        closeSlideoutPanelsExcept('facility-asset-sets');
        // Manage and Display Layers are mutually exclusive even when either
        // panel is floating.
        _assetSetVisualizationBarOpen = false;
    }
    _facilityAssetSetsBarOpen = flag;
}

function toggleAssetSetVisualizationBar(flag: boolean) {
    if (flag) {
        closeSlideoutPanelsExcept('asset-set-visualization');
        // Manage and Display Layers are mutually exclusive even when either
        // panel is floating.
        _facilityAssetSetsBarOpen = false;
    }
    _assetSetVisualizationBarOpen = flag;
}

//ontology
function setEditingFacilityOntology() {
    _dataSourcesVisible = false;
    _ontologyModalVisible = true;
}
function finishedEditingOntology() {
    _ontologyModalVisible = false;
}
function updateGraphicSourceObject(data: IGraphicSource) {
    _selectedGraphicSource = data;
    _hasGraphicSourceChange = true;

}
function setSelectedGraphicSource(data: IGraphicSource) {
    _hasGraphicSourceChange = false;
    _selectedGraphicSource = data;
    _cad3dModalVisible = true;
}
function graphicSourceModalClose() {
    _hasGraphicSourceChange = false;
    _selectedGraphicSource = null;
    _cad3dModalVisible = false;
}
function setGraphicSource(data: IGraphicSource[]) {
    _graphicSources = data;
}

//configurations
function setConfigurationSetting() {
    _dataSourcesVisible = false;
    _configurationModalVisible = true;
    //_initalizeValidation(FORM_ADD_FACILITY_NAME);
}
function resetConfigurationSetting() {
    _configurationModalVisible = false;
}
function _setConfiguration(data: any) {
    _configuration = data;
}
function setSchemaAssetSetTaxonomyData(data: ILibraryTaxonomyDetail) {
    _schemaAssetSetTaxonomyDetail = data;
    _hasSchemaChanges = false;
}
function updateSchemaAssetSetTaxonomyData(data: ILibraryTaxonomyDetail) {
    _schemaAssetSetTaxonomyDetail = data;
    _hasSchemaChanges = true;
}
function toggleTaxonomyModal(isVisible: boolean) {
    if (isVisible) {
        _dataSourcesVisible = false;
    }
    _taxonomyModalVisible = isVisible;
}
function setTaxonomyData(data: ILibraryTaxonomyDetail[]) {
    _libraryTaxonomy = data;
}
function setTaxonomyClassificationData(data: ILibraryTaxonomyDetail) {
    if (data.Type === TaxonomyType.KB) {
        _taxonomyClassificationDetail = data;
    } else if (data.Type === TaxonomyType.AssetSet) {
        _taxonomyAssetSetClassificationDetail = data;
    }
}
function setVisibleTaxonomyClassificationData(data: ILibraryTaxonomyDetail) {
    if (data.Type === TaxonomyType.KB) {
        _visibleTaxonomyClassificationDetail = data;
    } else if (data.Type === TaxonomyType.AssetSet) {
        _visibleTaxonomyAssetSetClassificationDetail = data;
    }
}
function updateTaxonomyClassificationData(data: ILibraryTaxonomyDetail) {
    if (data.Type === TaxonomyType.KB) {
        _taxonomyClassificationDetail = data;
    } else if (data.Type === TaxonomyType.AssetSet) {
        _taxonomyAssetSetClassificationDetail = data;
    }
    _hasTaxonomyChanges = true;
}
function finishedEditingTaxonomy(modalVisible: boolean = false) {
    _taxonomyModalVisible = modalVisible;
    _hasTaxonomyChanges = false;
}
function _updateConfigTagDisplayChanges(name: string, value: any) {
    switch (name) {
        case "FontColor":
            _configuration.TagDisplayData.FontColor = value;
            break;
        case "FontSize":
            _configuration.TagDisplayData.FontSize = value;
            break;
        case "FontStyle":
            _configuration.TagDisplayData.FontStyle = value;
            break;
        case "LineColor":
            _configuration.TagDisplayData.LineColor = value;
            break;
        case "LineThickness":
            _configuration.TagDisplayData.LineThickness = value;
            break;
        case "TagColor":
            _configuration.TagDisplayData.TagColor = value;
            break;
        case "TagShape":
            _configuration.TagDisplayData.TagShape = value;
            break;
        case "TagTransparency":
            _configuration.TagDisplayData.TagTransparency = value;
            break;
        default:
            throw new Error(`Unknown configuration tag display property: ${name}`);
    }
}
function _updateConfigAttributeChanges(name: string, value: any) {
    switch (name) {
        case "AttributeDefinitions":
            _configuration.AttributeDefinitions = value;
            break;
        default:
            throw new Error(`Unknown configuration attribute property: ${name}`);
    }
}
function _updateConfigExternalAttributeChanges(name: string, value: any) {
    switch (name) {
        case "ExternalDataSourceLinks":
            _configuration.ExternalDataSourceLinks = value;
            break;
        case "ExternalAttributeDefinitions":
            _configuration.ExternalAttributeDefinitions = value;
            break;
        default:
            throw new Error(`Unknown configuration external attribute property: ${name}`);
    }
}
function _updateConfigFriendClassChanges(name: string, value: any) {
    switch (name) {
        case "FriendClasses":
            _configuration.FriendClasses = value;
            break;
        case "AutoPopulateAssetSets":
            _configuration.AutoPopulateAssetSets = value;
            break;
        case "AutoPopulateAssetSetClassificationTags":
            _configuration.AutoPopulateAssetSetClassificationTags = value;
            break;
        default:
            throw new Error(`Unknown configuration friend class property: ${name}`);
    }
}
function finishedEditingConfiguration(modalVisible: boolean = false) {
    if (_configuration && !_configuration.ID) {
        _assetUpdateClasses = _assetUpdateClasses && _assetUpdateClasses.filter((item) => item.ID);
    }

    _configurationModalVisible = modalVisible;
    _hasSchemaChanges = false;
}
function updateCurrentConfigurationProperty(comp: string, key: string, value: any) {
    switch (comp) {
        case ConfigurationConstants.CONFIGURATION_FORM_TAGDISPLAYDATA:
            _updateConfigTagDisplayChanges(key, value);
            _hasSchemaChanges = true;
            break;
        case ConfigurationConstants.CONFIGURATION_FORM_ATTRIBUTEDATA:
            _updateConfigAttributeChanges(key, value);
            _hasSchemaChanges = true;
            break;
        case ConfigurationConstants.CONFIGURATION_FORM_EXTERNALATTRIBUTEDATA:
            _updateConfigExternalAttributeChanges(key, value);
            _hasSchemaChanges = true;
            break;
        case ConfigurationConstants.CONFIGURATION_FORM_FRIENDCLASSES:
            _updateConfigFriendClassChanges(key, value);
            _hasSchemaChanges = true;
            break;
    }
}
function openKnowledgeLibrary() {
    _knowledgeLibraryOpen = true;
    _facilityAssetSetsBarOpen = false;
    _assetSetVisualizationBarOpen = false;
    _mediaGalleryOpen = false;
}

function closeKnowledgeLibrary() {
    _knowledgeLibraryOpen = false;
    setKnowledgeLibraryCardUrlState({ isCardView: _knowledgeLibraryCardUrlState.isCardView, classificationTagId: undefined, knowledgeBookId: undefined });
}

function setKnowledgeLibraryCardUrlState(state: Partial<KnowledgeLibraryCardUrlState>) {
    _knowledgeLibraryCardUrlState = {
        ..._knowledgeLibraryCardUrlState,
        ...state
    };
}

function openMediaGallery() {
    _mediaGalleryOpen = true;
    _knowledgeLibraryOpen = false;
}

function closeMediaGallery() {
    _mediaGalleryOpen = false;
}

function setMediaGalleryViewMode(viewMode: MediaGalleryViewMode) {
    _mediaGalleryViewMode = viewMode;
}

function facilityAdapters(data: any) {
    if (data?.isUpdate) {
        _hasChanges = data.isUpdate;
    }
    _adapters = data.data;
}
function toggleXMLEditor(flag: boolean) {
    _xmlEditorOpen = flag;
}
function setXMLEditorData(data: any) {
    _xmlEditorData = data;
}
function toggleAssetTagbar(status: boolean) {
    if (status) {
        closeSlideoutPanelsExcept('asset-tags');
    }
    _assetTagBarOpen = status;
    _assetSearchbarOpen = status; // Keep in sync for viewer switching
}

function toggleMeasurementbar(status: boolean) {
    if (status) {
        closeSlideoutPanelsExcept('measurements');
    }
    _measurementBarOpen = status;
}
function toggleAssemblyLibrarybar(status: boolean) {
    if (status) {
        closeSlideoutPanelsExcept('assembly-library');
    }
    _assemblyLibraryBarOpen = status;
}
function setSelectedOntology(ontology: IOntologyPart) {
    _selectedOntology = ontology;
    _selectedOntologyContentTypes = null;
    
    if (_selectedOntology) {
        _selectedOntologyContentTypes = buildOntologyContentTypes(_selectedOntology);
    }
}
function setOntologyFormDirty(dirty: boolean) {
    _ontologyFormDirty = dirty;
}
function getRootOntology(): IOntologyPart {
    return _facilityDetails?.OntologyParts.find(o => !o.OntologyParentID);
}

function buildOntologyContentTypes(selectedOntology: IOntologyPart | null): string[] {
    if (!_facilityDetails?.OntologyParts?.length || !selectedOntology) {
        return [];
    }

    const partMap: { [id: string]: IOntologyPart } = {};
    _facilityDetails.OntologyParts.forEach(part => {
        partMap[part.ID] = part;
    });

    const allTypes: { [key: string]: boolean } = {};

    function collectTypes(part: IOntologyPart | undefined, allowAssets: boolean) {
        if (!part?.ContentTypes) return;

        part.ContentTypes.forEach(t => {
            if (!allowAssets && t === "Assets") return;
            allTypes[t] = true;
        });
    }

    const visitedUp: { [key: string]: boolean } = {};
    function walkUp(part: IOntologyPart | undefined) {
        while (part && !visitedUp[part.ID]) {
            visitedUp[part.ID] = true;

            // Allow "Assets" when walking up
            collectTypes(part, true);

            part = part.OntologyParentID ? partMap[part.OntologyParentID] : undefined;
        }
    }

    const visitedDown: { [key: string]: boolean } = {};
    function walkDown(part: IOntologyPart | undefined) {
        if (!part || visitedDown[part.ID]) return;

        visitedDown[part.ID] = true;

        // Allow "Assets" when walking down
        collectTypes(part, true);

        for (const id in partMap) {
            const child = partMap[id];
            if (child.OntologyParentID === part.ID) {
                walkDown(child);
            }
        }
    }

    walkUp(selectedOntology);
    walkDown(selectedOntology);

    return Object.keys(allTypes);
}

var FacilityStore: IFacilityStore = assign({}, EventEmitter.prototype, {
    getAll: function () {
        return _facilities;
    },
    getFacility: function () {
        return _facility;
    },
    getSelectedFacility: function () {
        return _facilityDetails;
    },
    getSearchResults: function () {
        return _searchResults;
    },
    getSchemas: function () {
        return _schemas;
    },    
    getAssetClasses: function () {
        return _assetUpdateClasses;
    },
    getFacilityAssetsData: function () {
        return getCachedFacilityAssetsData();
    },
    getBlankAssetClassUpdateDetail: function () {
        return { ...blankAssetClassUpdateDetail };
    },
    getFacilityHierarchy: function () {
        return _facilityDetails ? createFacilityHierarchy() : null;
    },
    getRootOntologyPart: function () {
        return getRootOntology();
    },
    getOntologyMapBoundsMap(): IOntologyMapBounds {
        const map: IOntologyMapBounds = {};

        if (!_facilityDetails?.OntologyParts?.length) {
            return map;
        }

        _facilityDetails.OntologyParts.forEach((part) => {
            const siteMap = part.Map;
            if (!part?.ID || !siteMap) return;
            if (!siteMap.RealWorldMin || !siteMap.RealWorldMax) return;

            if (part.MapType !== "inherit") {
                map[part.ID] = {
                    min: {
                        X: siteMap.RealWorldMin.X,
                        Y: siteMap.RealWorldMin.Y
                    },
                    max: {
                        X: siteMap.RealWorldMax.X,
                        Y: siteMap.RealWorldMax.Y
                    }
                };
            }
        });

        return map;
    },
    getOntologyHierarchyMap(): IOntologyHierarchyMap {
        const hierarchy: IOntologyHierarchyMap = {};

        if (!_facilityDetails?.OntologyParts?.length) {
            return hierarchy;
        }

        const parts = _facilityDetails.OntologyParts;

        parts.forEach((part) => {
            hierarchy[part.ID] = {
                id: part.ID,
                parentId: part.OntologyParentID || null,
                childIds: []
            };
        });

        parts.forEach((part) => {
            if (part.OntologyParentID && hierarchy[part.OntologyParentID]) {
                hierarchy[part.OntologyParentID].childIds.push(part.ID);
            }
        });

        return hierarchy;
    },
    getOntologyBoundsContext(): IOntologyBoundsContext {
        const selectedOntology = _selectedOntology
            ? _selectedOntology
            : (_facilityDetails?.OntologyParts?.length ? getRootOntology() : null);

        return {
            selectedOntologyId: selectedOntology?.ID,
            mapBoundsByOntologyId: this.getOntologyMapBoundsMap(),
            ontologyHierarchy: this.getOntologyHierarchyMap()
        };
    },
    getSelectedOntologyPartViews: function (): IView360Detail[] {
        if (!_facilityDetails) return [];

        // pick selected or root (same pattern as content types)
        var selectedOntology = _selectedOntology
            ? _selectedOntology
            : (_facilityDetails.OntologyParts && _facilityDetails.OntologyParts.length > 0)
                ? getRootOntology()
                : null;

        if (!selectedOntology) return [];

        // index parts
        const partMap: { [id: string]: IOntologyPart } = {};
        _facilityDetails.OntologyParts.forEach(part => {
            partMap[part.ID] = part;
        });

        // collect all part IDs in the chain (ancestors + self + descendants)
        const inChain: { [id: string]: boolean } = {};

        function mark(part: IOntologyPart | undefined) {
            if (!part) return;
            inChain[part.ID] = true;
        }

        // walk up to ancestors
        const visitedUp: { [key: string]: boolean } = {};
        function walkUp(part: IOntologyPart | undefined) {
            while (part && !visitedUp[part.ID]) {
                visitedUp[part.ID] = true;
                mark(part);
                part = part.OntologyParentID ? partMap[part.OntologyParentID] : undefined;
            }
        }

        // walk down to descendants
        const visitedDown: { [key: string]: boolean } = {};
        function walkDown(part: IOntologyPart | undefined) {
            if (!part || visitedDown[part.ID]) return;
            visitedDown[part.ID] = true;
            mark(part);
            for (const id in partMap) {
                const child = partMap[id];
                if (child.OntologyParentID === part.ID) {
                    walkDown(child);
                }
            }
        }

        walkUp(selectedOntology);
        walkDown(selectedOntology);

        // finally, filter views whose OntologyPartID is in the chain
        // (assumes each view has a nullable/optional OntologyPartID field)
        const views = _facilityDetails.Views || [];
        return views.filter(v => !!v?.OntologyID && inChain[v.OntologyID]);
    },

    getSelectedOntologyPartContentTypes: function (): string[] {
        return _selectedOntologyContentTypes || _rootOntologyContentTypes;
    },
    getRootOntologyContentTypes: function (): string[] {
        return _rootOntologyContentTypes;
    },
    
    getBlankSiteMap: function () {
        return getBlankSiteMap();
    },
    getAssetById: function (id: string) {
        return _facilityDetails?.Assets.find(a => a.ID === id);
    },
    getAssetTagById: function (id: string) {
        return _facilityDetails?.AssetTags.find(t => t.ID === id);
    },
    getNativeAssetByHierarchyItemId: function (id: string) {
        return _facilityDetails?.NativeAssets.find(na => na.HierarchyItemID === id);
    },
    getIsAdding: function () {
        return _beginAdd;
    },
    getIsEditing: function () {
        return _beginEdit;
    },
    getModalVisible: function () {
        return _modalVisible;
    },
    getSidebarOpen: function () {
        return _sidebarOpen;
    },
    getSearchbarOpen: function () {
        return _searchbarOpen;
    },
    getAssetSearchbarOpen: function () {
        return _assetSearchbarOpen;
    },
    getHasChanges: function () {
        return _hasChanges;
    },
    getHasSchemaChanges: function () {
        return _hasSchemaChanges;
    }, 
    getSchemaAssetSetTaxonomyDetail: function () {
        return _schemaAssetSetTaxonomyDetail;
    },
    getValidation(key: string) {
        return _validation[key];
    },
    getIsValidObject(key: string) {
        _validateIntegration();
        return _validate(key) && _validateIntegration();
    },
    getSelectedTab() {
        return _selectedTab;
    },
    getConfigurationModalVisible: function () {
        return _configurationModalVisible;
    },
    getTaxonomyModalVisible: function () {
        return _taxonomyModalVisible;
    },
    getOntologyModalVisible: function () {
        return _ontologyModalVisible;
    },
    getDataSourcesVisible: function () {
        return _dataSourcesVisible;
    },
    getCad3DModalVisible: function () {
        return _cad3dModalVisible;
    },
    getSelectedGraphicSource: function () {
        return _selectedGraphicSource;
    },
    getHasGraphicSourceChange: function () {
        return _hasGraphicSourceChange;
    },
    getGraphicSources: function () {
        return _graphicSources;
    },
    getConfiguration: function () {
        return _configuration;
    },
    getKnowledgeBookbarOpen: function () {
        return _knowledgeBookOpen;
    },
    getKnowledgeViewEditBarOpen: function () {
        return _knowledgeViewEditBarOpen;
    },
    getFacilityAssetSetsBarOpen: function () {
        return _facilityAssetSetsBarOpen;
    },
    getAssetSetVisualizationBarOpen: function () {
        return _assetSetVisualizationBarOpen;
    },
    getKnowledgeLibraryOpen() {
        return _knowledgeLibraryOpen;
    },
    getMediaGalleryOpen() {
        return _mediaGalleryOpen;
    },
    getMediaGalleryViewMode() {
        return _mediaGalleryViewMode;
    },
    getKnowledgeLibraryCardUrlState() {
        return _knowledgeLibraryCardUrlState;
    },
    getFacilityAdapters() {
        return _adapters;
    }, 
    getXMLEditorOpen() {
        return _xmlEditorOpen;
    },
    getXMLEditorData() {
        return _xmlEditorData;
    },
    getIsValidIntegrations() {
        return _validateIntegration();
    },
    getIsFormSubmitted() {
        return _isFormSubmitted;
    },
    getTabsError() {
        return _tabError;
    },
    getAssetTagbarOpen: function () {
        return _assetTagBarOpen;
    },
    getMeasurementbarOpen: function () {
        return _measurementBarOpen;
    },
    getAssemblyLibrarybarOpen: function () {
        return _assemblyLibraryBarOpen;
    },
    getSelectedOntology: function () {
        var selectedOntology = _selectedOntology ? _selectedOntology : (_facilityDetails != null && _facilityDetails.OntologyParts && _facilityDetails.OntologyParts.length > 0) ? getRootOntology() : null;

        return selectedOntology;
    },
    getOntologyFormDirty: function () {
        return _ontologyFormDirty;
    },
    getHasTaxonomyChanges: function () {
        return _hasTaxonomyChanges;
    }, 
    getLibraryTaxonomyDetail: function () {
        return _libraryTaxonomy.sort((a, b) => {
            return a.Name.localeCompare(b.Name);
        });
    },
    getTaxonomyClassificationDetail: function (type: TaxonomyType = TaxonomyType.KB) {
        if (type === TaxonomyType.AssetSet) {
            return _taxonomyAssetSetClassificationDetail;
        }
        return _taxonomyClassificationDetail;
    },
    getVisibleTaxonomyClassificationDetail: function (type: TaxonomyType = TaxonomyType.KB) {
        if (type === TaxonomyType.AssetSet) {
            return _visibleTaxonomyAssetSetClassificationDetail || _taxonomyAssetSetClassificationDetail;
        }
        return _visibleTaxonomyClassificationDetail || _taxonomyClassificationDetail;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback:any) {
        this.removeListener(CHANGE_EVENT, callback);
    },
});

// This sets max listeners on event emitters. Prevents a warn presents in console for more that 10. Setting to larger
// than 10 is fine, and suppressing that warning. You just don't want to add leaking emitters, or recursively add listeners 
// so that it balloons and crashes.
(FacilityStore as any).setMaxListeners?.(20);

Inovx.Shared.Flux.AppDispatcher.register(function (payload: any) {
    switch (payload.actionType) {
        case FacilityConstants.FACILITY_GET_ALL:
            loadAllFacilities(payload.data);
            break;
        case FacilityConstants.FACILITY_RECEIVE_SEARCH_RESULTS:
            loadSearchResults(payload.data);
            break;
        case FacilityConstants.FACILITY_BEGIN_ADD:
            setAddingFacility();
            break;
        case FacilityConstants.FACILITY_BEGIN_EDIT:
            setEditingFacility(payload.facility);
            break;
        case FacilityConstants.FACILITY_FINISH_EDIT:
            finishedEditingFacility(payload.close);
            break;
        case FacilityConstants.FACILITY_UPDATE_EDIT:
            updateCurrentProperty(payload.component, payload.key, payload.value);
            break;
        case FacilityConstants.FACILITY_DETAILS:
            setFacilityDetails(payload.facility);
            break;
        case FacilityConstants.UPDATE_FACILITY_DETAILS:
            updateFacilityDetails(payload.data);
            break;
        case FacilityConstants.FACILITY_DETAILS_RESET:
            resetFacilityDetails();
            break;
        case FacilityConstants.FACILITY_OPEN_SIDEBAR:
            openSidebar();
            break;
        case FacilityConstants.FACILITY_CLOSE_SIDEBAR:
            closeSidebar();
            break;
        case FacilityConstants.FACILITY_OPEN_SEARCHBAR:
            openSearchbar();
            break;
        case FacilityConstants.FACILITY_CLOSE_SEARCHBAR:
            closeSearchbar();
            break;
        case FacilityConstants.FACILITY_OPEN_ASSET_SEARCHBAR:
            openAssetSearchbar();
            break;
        case FacilityConstants.FACILITY_CLOSE_ASSET_SEARCHBAR:
            closeAssetSearchbar();
            break;
        // Note: VIEWER_SHOW_IMAGE and VIEWER_SHOW_ONTOLOGY_3D no longer close the asset searchbar
        // to allow the AssetTagsBar to remain open when switching between viewers
        case FacilityConstants.FACILITY_INVALID_ADD:
            break;
        case FacilityConstants.FACILITY_SELECTED_TAB:
            updateSelectedTab(payload.tab);
            break; 
        case FacilityConstants.FACILITY_OPEN_DATA_SOURCES:
            openDataSources();
            break;
        case FacilityConstants.FACILITY_CLOSE_DATA_SOURCES:
            closeDataSources();
            break;
        case FacilityConstants.FACILITY_RECEIVE_ASSET_UPDATE_CLASSES:
            setAssetUpdateClasses(payload.data);
            break;
        case FacilityConstants.FACILITY_UPDATE_ASSET_UPDATE_CLASS:
            updateAssetUpdateClass(payload.data);
            break;
        case FacilityConstants.FACILITY_RECEIVE_SCHEMA_ASSET_SET_TAXONOMY:
            setSchemaAssetSetTaxonomyData(payload.data);
            break;
        case FacilityConstants.FACILITY_UPDATE_SCHEMA_ASSET_SET_TAXONOMY:
            updateSchemaAssetSetTaxonomyData(payload.data);
            break;
        case FacilityConstants.FACILITY_RECEIVE_SCHEMAS:
            loadAllSchemas(payload.data);
            break;
        case FacilityConstants.FACILITY_REFRESH_ASSETTAG:
            refreshAssetTagData(payload.data);
            break;
        case FacilityConstants.FACILITY_DELETE_ASSETTAG:
            deleteAssetTag(payload.data);
            break;
        case GraphicSourceConstants.GRAPHIC_SOURCE_UPDATE_OBJECT:
            updateGraphicSourceObject(payload.data);
            break
        case GraphicSourceConstants.GRAPHIC_SOURCE_EDIT:
            setSelectedGraphicSource(payload.data);
            break
        case GraphicSourceConstants.GRAPHIC_SOURCE_MODAL_CLOSE:
            graphicSourceModalClose();
            break
        case GraphicSourceConstants.GRAPHIC_SOURCE_FINISH_EDIT:
            graphicSourceModalClose();
            break
        case GraphicSourceConstants.GRAPHIC_SOURCES:
            setGraphicSource(payload.data);
            break
        case ConfigurationConstants.CONFIGURATION_FINISH_EDIT:
            finishedEditingConfiguration(payload.modalVisible);
            break;
        case ConfigurationConstants.CONFIGURATION_BEGIN_EDIT:
            setConfigurationSetting();
            break;
        case ConfigurationConstants.CONFIGURATION_BEGIN_FINISH:
            resetConfigurationSetting();
            break
        case ConfigurationConstants.CONFIGURATION_SET_DATA:
            _setConfiguration(payload.data);
            break;
        case ConfigurationConstants.CONFIGURATION_UPDATE_EDIT:
            updateCurrentConfigurationProperty(payload.component, payload.key, payload.value);
            break;
        case TaxonomyConstants.TOGGLE_TAXONOMY_MODAL:
            toggleTaxonomyModal(payload.data.isVisible);
            break;
        case TaxonomyConstants.TAXONOMY_SET_DATA:
            setTaxonomyData(payload.data);
            break;
        case TaxonomyConstants.TAXONOMY_CLASIFICATION_DATA:
            setTaxonomyClassificationData(payload.data);
            break;
        case TaxonomyConstants.TAXONOMY_VISIBLE_CLASIFICATION_DATA:
            setVisibleTaxonomyClassificationData(payload.data);
            break;
        case TaxonomyConstants.TAXONOMY_CLASIFICATION_UPDATE_DATA:
            updateTaxonomyClassificationData(payload.data);
            break;
        case TaxonomyConstants.TAXONOMY_FINISH_EDIT:
            finishedEditingTaxonomy(payload.modalVisible);
            break;
        /*
        case FacilityConstants.FACILITY_HIDE_ANNOTATIONS:
            hideAnnotations();
            break;
        case FacilityConstants.FACILITY_SHOW_ANNOTATIONS:
            showAnnotations();
            break;
        case FacilityConstants.FACILITY_SHOW_ANNOTATION:
            showAnnotation(payload.data.annotation);
            break;
        case FacilityConstants.FACILITY_HIDE_ANNOTATION:
            hideAnnotation(payload.data.annotation);
            break;
            */
        case FacilityConstants.FACILITY_OPEN_KNOWLEDGE_BOOK_BAR:
            toggleKnowledgeBookbar(true);
            break;
        case FacilityConstants.FACILITY_CLOSE_KNOWLEDGE_BOOK_BAR:
            toggleKnowledgeBookbar(false);
            break;
        case FacilityConstants.FACILITY_OPEN_KNOWLEDGE_VIEW_EDIT_BAR:
            toggleKnowledgeViewEditBar(true);
            break;
        case FacilityConstants.FACILITY_CLOSE_KNOWLEDGE_VIEW_EDIT_BAR:
            toggleKnowledgeViewEditBar(false);
            break;
        case FacilityConstants.FACILITY_OPEN_ASSET_SETS_BAR:
            toggleFacilityAssetSetsbar(true);
            break;
        case FacilityConstants.FACILITY_CLOSE_ASSET_SETS_BAR:
            toggleFacilityAssetSetsbar(false);
            break;
        case FacilityConstants.FACILITY_OPEN_ASSET_SET_VISUALIZATION_BAR:
            toggleAssetSetVisualizationBar(true);
            break;
        case FacilityConstants.FACILITY_CLOSE_ASSET_SET_VISUALIZATION_BAR:
            toggleAssetSetVisualizationBar(false);
            break;
        case FacilityConstants.FACILITY_OPEN_KNOWLEDGE_LIBRARY:
            openKnowledgeLibrary();
            break;
        case FacilityConstants.FACILITY_CLOSE_KNOWLEDGE_LIBRARY:
            closeKnowledgeLibrary();
            break;
        case FacilityConstants.FACILITY_OPEN_MEDIA_GALLERY:
            openMediaGallery();
            break;
        case FacilityConstants.FACILITY_CLOSE_MEDIA_GALLERY:
            closeMediaGallery();
            break;
        case FacilityConstants.FACILITY_SET_MEDIA_GALLERY_VIEW_MODE:
            setMediaGalleryViewMode(payload.viewMode);
            break;
        case FacilityConstants.FACILITY_SET_KNOWLEDGE_LIBRARY_CARD_URL_STATE:
            setKnowledgeLibraryCardUrlState(payload.state);
            break;
        case FacilityConstants.FACILITY_ADAPTERS:
            facilityAdapters(payload.params);
            break;
        case FacilityConstants.TOGGLE_XML_EDITOR:
            toggleXMLEditor(payload.flag);
            break;
        case FacilityConstants.SET_XML_EDITOR_DATA:
            setXMLEditorData(payload.data);
            break;
        case FacilityConstants.TOGGLE_ASSET_TAGBAR:
            toggleAssetTagbar(payload.status);
            break;
        case FacilityConstants.TOGGLE_MEASUREMENTBAR:
            toggleMeasurementbar(payload.status);
            break;
        case FacilityConstants.TOGGLE_ASSEMBLYLIBRARYBAR:
            toggleAssemblyLibrarybar(payload.status);
            break;
        case OntologyConstants.ONTOLOGY_BEGIN_EDIT:
            setEditingFacilityOntology();
            break;
        case OntologyConstants.ONTOLOGY_FINISH_EDIT:
            finishedEditingOntology();
            break;
        case OntologyConstants.ONTOLOGY_SELECT:
            setSelectedOntology(payload.ontology);
            break;
        case OntologyConstants.ONTOLOGY_SET_DIRTY:
            setOntologyFormDirty(payload.dirty);
            return true; // We don't want to emit change for this action!
        default:
            return true;
    }

    FacilityStore.emitChange();

    return true;
});

export default FacilityStore;
